import { IMAGE } from '../elements/assets'

export const AGENDA_GRID = `
...on agendaGrid_Entry {
  id
  typeHandle

  headingAdvanced {
    html
  }

  agendaSessions {
    id
    time
    title
    description
    tags {
      id
      title
    }
    speaker {
      id
      title
      description
      ${ IMAGE }
    }
  }

}
`